<template>
  <v-dialog
    width="480"
    :value="value"
    :persistent="true"
  >
    <v-card>
      <v-card-title
        class="headline primary white--text"
      >
        <template>ログイン</template>
      </v-card-title>

      <v-card-text class="text--primary pt-4">
        <p class="mb-0">予約を進めるにはログインが必要です。</p>
        <p class="mb-0">
          すでに会員の方は<strong class="red--text">ログイン</strong>してください。
          まだ会員になっていない方は<strong class="red--text">会員登録</strong>をお願い致します。
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary" class="w-24"
          @click="onNewUser"
        >
          会員登録
        </v-btn>
        <v-btn
          color="primary" class="w-24"
          @click="onLogin"
        >
          ログイン
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AlertLogin',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onLogin () {
      // 現在の URL を取得する
      const go = window.location.href

      // vue router を使用せずに URL を変更する
      window.location.href = '/bookin/netzfukuoka/user/login?go=' + encodeURIComponent(go)
    },

    onNewUser () {
      // 現在の URL を取得する
      const go = window.location.href

      // vue router を使用せずに URL を変更する
      window.location.href = '/bookin/netzfukuoka/user/new-user/agree?go=' + encodeURIComponent(go)
    }
  }
}
</script>
